import React from 'react';
import { withTheme } from 'styled-components';

const RemoveBookmarkIcon = ({ width, height, theme }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill={
        theme.themeColors.controlBar.rightPanel.icons.bookmarkIcon.colorOnFilled
      }
      xmlns="http://www.w3.org/2000/svg"
      data-ignore-click-outside="bookmarks-sidebar"
      title="Убрать страницу из закладок"
    >
      <path
        d="M23 25L23 3C23 2.44772 22.5523 2 22 2L14 2L6 2C5.44772 2 5 2.44772 5 3L5 25L14 17.6638L23 25Z"
        stroke={
          theme.themeColors.controlBar.rightPanel.icons.bookmarkIcon
            .colorOnFilled
        }
        strokeWidth="2"
        data-ignore-click-outside="bookmarks-sidebar"
      />
    </svg>
  );
};

export default withTheme(RemoveBookmarkIcon);
